import {
  FETCH_APPOINTMENTLIST_REQUEST,
  FETCH_APPOINTMENTLIST_SUCCESS,
  FETCH_APPOINTMENTLIST_FAILURE,
} from "./appointmentListTypes";
import api from "../../utils/Api";
import axios from 'axios';

export const fetchAppointmentListRequest = () => {
  return {
    type: FETCH_APPOINTMENTLIST_REQUEST,
  };
};

export const fetchAppointmentListSuccess = (AppointmentList) => {
  return {
    type: FETCH_APPOINTMENTLIST_SUCCESS,
    payload: AppointmentList,
  };
};

export const fetchAppointmentListFailure = (error) => {
  return {
    type: FETCH_APPOINTMENTLIST_FAILURE,
    payload: error,
  };
};

const CancelToken = axios.CancelToken;
let cancelRequest;
export const fetchAppointmentList = (payload, queryString, sortBy, page, appointmentStatus, isTodaysAppointmentist, isWaitingList,outstandingInvoices,pastAppointmentCount) => {
  //cancel previous request if multiple hits done.
  cancelRequest && cancelRequest();
  const headers = {
    Authorization:
      "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
  };
  let url = "appointment?sort_by=" + sortBy + "&page=" + page + queryString;
  if(isTodaysAppointmentist){
    url += "&isTodaysAppointmentist="+ isTodaysAppointmentist
  }
  if(isWaitingList){
    url += "&isWaitingList="+ isWaitingList
  }
  if(outstandingInvoices){
    url += "&outstandingInvoices="+ outstandingInvoices
  }
  if(appointmentStatus){
    url += "&lk_appointment_status_id="+ appointmentStatus
  }
  if(payload && payload.dateFrom){
    url += "&appointment_date=gte:"+ payload.dateFrom;
  }
  if(payload && payload.dateTo){
    url += "&appointment_date=lte:"+  payload.dateTo
  }
  if(pastAppointmentCount){
    url += "&pastAppointmentCount="+ pastAppointmentCount    
  }
  return async (dispatch) => {
    dispatch(fetchAppointmentListRequest());
    try {
      const response = await api.get(url,
        {
          headers: headers,
          cancelToken: new CancelToken(function executor(c) {
            cancelRequest = c;
        })
        }
      );
      const appointmentList = response.data.data;
     // console.log("****** appointment list response", appointmentList);
      dispatch(fetchAppointmentListSuccess(appointmentList));
    } catch (error) {
      if (axios.isCancel(error)) {
        console.log('Error: ', error.message); // => prints: Api is being canceled
      } 
      console.log("Redux error - ", error.response);
      const errorMsg = error.message;
      dispatch(fetchAppointmentListFailure(errorMsg));
    }
  };
};
